import React from 'react'

import { Typography } from "@mui/material";

interface InstructionStepProps {
  title: string
  url: string
  videoUrl?: string
}

export function InstructionStep({ title, url, videoUrl }: InstructionStepProps) {
  return <Typography color="text.secondary" sx={{ mt: 1 }} variant="body2">
    <ol>
      <li>
        Download the <a href={url}>XLSX template</a>
      </li>
      <li>
        Fill out the XLSX template with your {title} data.{" "}. You will be able to manually map the column before importing
      </li>
      <li>
        Upload the XLSX file below. You will be able to review the data
        before importing.
      </li>
    </ol>
    {videoUrl && <p>Please watch the video <a href={videoUrl} target="_blank">here</a> for more information</p>}
  </Typography>
}
